import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledBreadcrumb } from 'utils/styles';
import { goTo } from 'utils/util';

interface Props {
  label: string;
  url: string;
  state?: Nullable<any>;
}

export const SimpleCrumb: React.FC<Props> = ({ label, url, state }): JSX.Element => <StyledBreadcrumb label={label} onClick={goTo(url, useNavigate(), state)} />;
